import { Badge } from "@/components/ui/badge";
import {
  type AttentionRow,
  attentionColumnParts,
} from "@/lib/attention-column";
import type { ReactNode } from "react";

export function AttentionBadges({
  row,
  includeReadyForCheck = false,
  empty = null,
}: {
  row: AttentionRow;
  includeReadyForCheck?: boolean;
  empty?: ReactNode;
}) {
  const parts = attentionColumnParts(row, includeReadyForCheck);
  if (parts.labels.length === 0) return empty;
  return (
    <div className="flex flex-wrap gap-1">
      {parts.labels.map((label) => (
        <Badge
          key={label}
          variant={label === "Ready for Check" ? "outline" : "warning"}
        >
          {label}
        </Badge>
      ))}
    </div>
  );
}
